<template>
  <div id="tutorialDocent" class="d-flex min-height align-items-center">
    <vue-headful title="TutorialDocent" />
    <header class="position-fixed w-100">
      <div class="container-fluid text-center">
        <div class="icon-wrapper">
          <svg
            id="derect"
            @click="gotoDashboard"
            viewBox="0 0 112.5 25.5"
            width="126px"
            height="28px"
          >
            <g transform="translate(-222 -962)">
              <g transform="translate(226 966)">
                <g transform="translate(30.766 64.069)">
                  <path
                    fill="#FFFFFF"
                    d="m-34.8-68.1h9.2c7.9 0 11.2 4.2 11.2 12 0 8.7-4.8 12.9-12.1 12.9h-8.3v-24.9zm5 4.3v16.1h2.9c5.1 0 7.3-3 7.3-8.3 0-4.5-1.7-7.8-6.3-7.8h-3.9zm24 12c0.4 3.4 2.2 4.8 5.4 4.8 2.4 0 4.2-0.7 5.3-1.4 0.5 0.7 0.7 1.5 0.7 2.4 0 2.4-3.2 3.3-6.9 3.3-6.2 0-9.5-3.3-9.5-9.9 0-5.7 3.1-10.1 8.9-10.1 5.3 0 7.9 3.6 7.9 8.2 0 1.1-0.2 2-0.3 2.7h-11.5zm0-3.2h7c0-2.6-1.2-3.8-3.2-3.8-2-0.1-3.4 1.3-3.8 3.8zm16.6-7.2h3.6c0.5 1.2 0.8 2.4 0.9 3.6h0.3c0.3-2.2 1.6-4.1 4.6-4.1 2.4 0 3.4 1 3.4 2.6 0 1.1-0.4 2.3-1.1 3.2-0.7-0.6-1.9-0.9-3.2-0.9-1.6 0-2.9 0.6-3.5 2v12.7h-4.9l-0.1-19.1zm19.4 10.4c0.4 3.4 2.2 4.8 5.4 4.8 2.4 0 4.2-0.7 5.3-1.4 0.5 0.7 0.7 1.5 0.7 2.4 0 2.4-3.2 3.3-6.9 3.3-6.2 0-9.5-3.3-9.5-9.9 0-5.7 3.1-10.1 8.9-10.1 5.3 0 7.9 3.6 7.9 8.2 0 1.1-0.2 2-0.3 2.7h-11.5zm0-3.2h7c0-2.6-1.2-3.8-3.2-3.8-2-0.1-3.4 1.3-3.8 3.8zm29.4-2.1c-0.8-0.6-2.2-1.1-4.2-1.1-3 0-4.7 2.1-4.7 5.7 0 3.2 1.6 5.4 4.9 5.4 1.8 0 3.4-0.6 4.3-1.3 0.6 0.7 1 1.7 1 2.6 0 2.1-2.5 3.1-6 3.1-6.7 0-9.3-3.8-9.3-9.5 0-6.2 3.2-10.5 9.8-10.5 2.2 0 5.3 0.5 5.3 2.9-0.1 0.9-0.4 1.8-1.1 2.7z"
                  />
                  <path
                    fill="#FFCD00"
                    d="m70.9-66.6v4.4h5.9v3.8h-5.9v8.6c0 1.9 0.8 2.6 2.4 2.6 1.3 0 2.4-0.4 3.3-1.1 0.7 0.8 1.1 1.6 1.1 2.5 0 1.8-2 3.2-5.5 3.2-4.2 0-6.2-1.9-6.2-6.2v-9.6h-2.8v-3.8h2.9v-1.2c0-2.4 1.4-3.3 3.4-3.3 0.7 0 1.1 0 1.4 0.1z"
                  />
                </g>
              </g>
            </g>
          </svg>
        </div>
        <h2 class="m-0 d-inline-block tagline text-white">Direct een extra kracht</h2>
      </div>
    </header>
    <div class="my-5 py-5 w-100">
      <div class="pt-4 px-4 mx-2">
        <div class="container-fluid px-0">
          <div class="d-block">
            <video ref="videoRef" controls>
              <source src="@/assets/derect_tutorial_voor_de_klas.mp4" type="video/mp4" />Your browser does not support HTML5 video.
            </video>
          </div>
        </div>
      </div>
    </div>
    <footer class="position-fixed w-100">
      <div class="container-fluid text-center">
        <p class="py-4 my-1">
          <a href="javascript:history.go(-1)" class="text-white"><strong>Back</strong></a>
          <!-- <router-link :to="{ name: 'tutorial' }" class="text-white">
            <strong>Back</strong>
          </router-link> -->
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  props: ["back"],
  mounted: function() {
    this.$refs.videoRef.play();
  },
  methods: {
    gotoDashboard() {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user) {
        if (user.type == 1) {
          this.$router
            .replace({
              name: "applicant-dashboard"
            })
            .catch(() => {});
        } else {
          this.$router
            .replace({
              name: "company-dashboard"
            })
            .catch(() => {});
        }
      } else {
        this.$router.replace({
          name: "login"
        });
      }
    }
  }
};
</script>

<style scoped>
.btn-outline-warning {
  width: 265px;
}
p {
  font: 18px/29px "Real Head Pro";
  font-weight: 200;
}
</style>
